import axios from 'axios';

/** The analysis is free until we say we received it — this is what actually spends the credit. */
export const confirmAnalysisCharge = async (apiUrl, token, chargeId) => {
  if (!chargeId) return null;
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const { data } = await axios.post(
        `${apiUrl}/api/analyze/confirm`,
        { charge_id: chargeId },
        { headers: { Authorization: `Bearer ${token}` }, timeout: 15000 }
      );
      return data.usage || null;
    } catch (err) {
      if (attempt === 1) return null;
    }
  }
  return null;
};
